import { render, staticRenderFns } from "./OrganizationBranchCellRendererActions.vue?vue&type=template&id=4b4f3fbe&scoped=true"
import script from "./OrganizationBranchCellRendererActions.vue?vue&type=script&lang=js"
export * from "./OrganizationBranchCellRendererActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f3fbe",
  null
  
)

export default component.exports